if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartDrawer = document.querySelector("cart-drawer");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        const cartItem = document.querySelector(`.drawer__content-item[data-variant-id="${formData.get("id")}"]`);
        if (cartItem) {
          document.querySelector("cart-items").updateQuantity(cartItem.dataset.line, parseInt(cartItem.dataset.itemQuantity) + 1);
          document.querySelector("cart-drawer").open();
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden"
          );
          return; 
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            console.log(response);
            this.cartDrawer.renderContents(response);
            //           this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.connected === "true") return;
    this.dataset.connected = "true";
  
    this.currentVariant = window.initialVariant;
    this.onVariantChangeBound = this.onVariantChange.bind(this);
    this.onVariantChange();
    this.addEventListener("change", this.onVariantChangeBound);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    //     this.updatePickupAvailability();
    this.setAvailabilities();
    this.removeErrorMessage();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      try {
        this.currentOptions();
      } catch (error) {
        console.error("Error in currentOptions:", error);
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateAddButton();
      this.updateAfterpay();
      if (event && event.target.name == "Color") {
        this.updateContent();
      }
      this.preOrder();
      // Note: too early to execute this.bis() here (this.currentVariant is not fully updated yet)
      // this.bis();
      this.stockNotice();
      this.wishlistId();
    }
    console.log("Current variant: ", this.currentVariant.id);
  }

  wishlistId() {
    const wishlistButton = document.querySelector(
      ".product__swym-wishlist-custom"
    );
    wishlistButton.setAttribute("data-variant-id", this.currentVariant.id);
    if (!window.wishlistVariantIds) return;
    if (window.wishlistVariantIds.indexOf(this.currentVariant.id) > -1) {
      wishlistButton.classList.add("swym-added");
    } else {
      wishlistButton.classList.remove("swym-added");
    }
  }

  currentOptions() {
    const currentValues = document.querySelectorAll(
      ".product-form__input .current-value"
    );
    currentValues.forEach((currentValue, i) => {
      const optionKey = `option${i + 1}`;
      currentValue.textContent = this.currentVariant[optionKey];
    });
  }

  preOrder() {
    const preOrderNotice = document.querySelector(".pre-order__notice");
    const submitButton = document.querySelector(".product-form__submit");
    if (!this.currentVariant.shipDate) {
      preOrderNotice?.classList.add("hidden");
      submitButton.classList.remove("preorder");
      return;
    }

    //     const klaviyoTrigger = document.querySelector('.klaviyo-bis-trigger');

    const submitText = submitButton.querySelector("span");
    const variantRadios = document.querySelectorAll(".variant-radio");

    //     klaviyoTrigger.style.display = 'none';
    submitButton.style.display = "block";
    submitButton.removeAttribute("disabled");
    submitText.textContent = "Pre-order";
    submitButton.classList.add("preorder");
    variantRadios.forEach((radio) => {
      radio.classList.remove("soldout");
    });
  }

  bis() {
    const bisWrapper = document.querySelector(".klaviyo-bis-wrapper");
    if ((this.currentVariant.inventory_quantity <= 0) && (this.currentVariant.inventory_policy != "continue") && !this.currentVariant.shipDate) {
      bisWrapper.style.display = "block";
    } else {
      bisWrapper.style.display = "none";
    }
  }

  updateContent(url = false) {
    const _this = this;
    const newUrl = url ? url : this.currentVariant.productUrl;

    if (!newUrl) return;

    const elementsToUpdate = [
      ".product__media-gallery",
      ".product-media-modal__content",
      ".product__description",
      ".product__title",
      ".metafield-rich_text_field",
      "#background-color",
      ".product__price",
      ".promo-text__wrapper",
      ".final-sale__wrapper",
      ".product__accordion--description .accordion__content",
      ".product__accordion--fabric .accordion__content",
      ".product__accordion--size-fit .accordion__content",
    ];

    if (this.hasSizes()) {
      elementsToUpdate.push(
        ".product-form__input[data-option='Size'] .variant-radios--wrapper"
      );
    }

    fetch(newUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        elementsToUpdate.forEach((element, i) => {
          var el = document.querySelector(element);
          if (!el) return true;
          el.innerHTML = doc.querySelector(element).innerHTML;
        });
        const accordions = document.querySelectorAll(".product__accordion");
        accordions.forEach((accordion) => {
          let accordionContent = accordion.querySelector(".accordion__content");
          let accordionContentId = accordionContent.getAttribute("id");
          let oldContent = document.querySelector("#" + accordionContentId);
          let newContent = doc.querySelector("#" + accordionContentId);
          if (!oldContent || !newContent) return true;
          oldContent.innerHTML = newContent.innerHTML;
        });
        _this.updateJson(newUrl);
        //       initSwiper();
        lazyLoadImages();
        //       initSwiper();
        const updateEvent = new Event("updateContent");
        document.querySelector(".template-product").dispatchEvent(updateEvent);
      })
      .catch(function (err) {
        // There was an error
        _this.finishLoading();
      })
      .finally(() => {
        playPauseVideo();
      });
  }

  updateJson(url) {
    fetch(`${url}?view=api-inventory`)
      .then((response) => response.json())
      .then((data) => {
        window.productJSON.variants.forEach((variant) => {
          data.forEach((newVariant) => {
            if (newVariant.id === variant.id) {
              variant.inventory_quantity = newVariant.inventory_quantity;
            }
          });
        });
        this.bis();
      })
      .catch((error) => console.log(error));
  }

  stockNotice() {
    const stockNotice = document.querySelector(".product__stock-notice");
    if (!stockNotice) return;

    const threshold = parseFloat(stockNotice.getAttribute("data-threshold"));
    if (
      this.currentVariant.inventory_quantity <= threshold &&
      this.currentVariant.inventory_quantity > 0
    ) {
      stockNotice.classList.remove("hidden");
      stockNotice.querySelector(".inventory-quantity").textContent =
        this.currentVariant.inventory_quantity;
    } else {
      stockNotice.classList.add("hidden");
    }
  }

  updateAfterpay() {
    const afterpayAmount = document.querySelector(".payment-installments");
    if (!afterpayAmount) return;
    afterpayAmount.textContent = Shopify.formatMoney(
      this.currentVariant.price / 4
    );
  }

  updateAddButton() {
    const button = document.querySelector(".product-form__submit");
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    );
    if (window.klaviyoBisEnabled) {
      if (this.currentVariant.available) {
        button.style.display = "block";
      } else {
      }
    }
  }

  hasSizes() {
    const sizeInputEl = document.querySelector(
      '.product-form__input[data-option="Size"]'
    );
    return typeof sizeInputEl != "undefined" && sizeInputEl != null
      ? sizeInputEl
      : false;
  }

  sizeChecked() {
    const sizeInput = document.querySelector(
      '.product-form__input[data-option="Size"] input:checked'
    );
    return typeof sizeInput != "undefined" && sizeInput != null
      ? sizeInput
      : false;
  }

  colorChecked() {
    const colorInput = document.querySelector(
      '.product-form__input[data-option="Color"] input:checked'
    );
    return typeof colorInput != "undefined" && colorInput != null
      ? colorInput
      : false;
  }

  setAvailabilities() {
    const colorChecked = this.colorChecked();
    if (!colorChecked) return;

    const colorCheckedValue = colorChecked.value;

    window.productJSON.variants.forEach((variant) => {
      if (variant.options[0] === colorCheckedValue) {
        const escapedOption = variant.options[1];
        const myInput = document.querySelector(
          `.product-form__input[data-option="Size"] input[value='${escapedOption}']`
        );
        if (myInput) {
          /* Check variant preOrder status */
          const variantLimit = variant.preOrderLimit;
          const variantQty = Math.abs(variant.inventory_quantity);
          const variantAvailable = variantQty < variantLimit;

          if (variant.shipDate) {
            if (variantAvailable) {
              myInput.classList.remove("soldout");
            } else {
              myInput.classList.add("soldout");
            }
          } else if (variant.available) {
            myInput.parentNode.classList.remove("soldout");
          } else {
            myInput.parentNode.classList.add("soldout");
          }
        }
      }
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL(url = false) {
    const currentUrl = window.location.href;

    const queryParams = {};
    const queryString = window.location.search.substring(1);
    const excludeParams = ["variant"];
    const pairs = queryString.split("&");

    // Build the queryParams object, excluding any excluded parameters
    for (let i = 0; i < pairs.length; i++) {
      const pair = pairs[i].split("=");
      const key = decodeURIComponent(pair[0]);
      const value = decodeURIComponent(pair[1]);
      if (!excludeParams.includes(key)) {
        queryParams[key] = value;
      }
    }

    const newQueryString = Object.keys(queryParams)
      .map(
        (key) =>
          encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])
      )
      .join("&");

    const newUrl = url
      ? url
      : this.currentVariant.productUrl + "?variant=" + this.currentVariant.id;
    if (!this.currentVariant && !url) return;
    window.history.replaceState(
      {},
      "",
      `${newUrl}${newQueryString ? `&${newQueryString}` : ""}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm && productForm.handleErrorMessage == "function") productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.currentVariant.productUrl}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        const badgesOld = document.querySelector(".product .badges");
        const badgesNew = html.querySelector(".product .badges");
        if (badgesOld && badgesNew) badgesOld.innerHTML = badgesNew.innerHTML;

        const preorderSource = html.getElementById(`Preorder-${this.dataset.section}`);
        const preorderDest = document.getElementById(`Preorder-${this.dataset.section}`);
        if (preorderDest && preorderSource) preorderDest.innerHTML = preorderSource.innerHTML;

        setupBadges();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.innerHTML = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.innerHTML = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    if (window.klaviyoBisEnabled) {
    } else {
      const button = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add("visibility-hidden");
    }
  }

  getVariantData() {
    this.variantData = this.variantData || window.productJSON.variants;
    return this.variantData;
  }
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    if (this.dataset.init === "true") return;
    this.dataset.init = "true";
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      )?.value || null;
    });
  }
}

function getSwatches(title) {
  fetch(`/search?q=title:${title}&type=product&view=product-swatches`)
    .then((response) => response.text())
    .then((data) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const sheet = doc.querySelector("style");
      document.head.appendChild(sheet);
    })
    .catch((e) => console.log(e));
}

function fancySwatches() {
  if (
    window.productJSON.options.indexOf("Color") === -1 ||
    window.productJSON.title.indexOf(" - ") === -1
  ) {
    if (!customElements.get("variant-selects")) {
      customElements.define("variant-selects", VariantSelects);
    }
    
    if (!customElements.get("variant-radios")) {
      customElements.define("variant-radios", VariantRadios);
    }
    return;
  }
  const productTitle = window.productJSON.title.split(" - ");
  const swatchStyles = [];
  fetch(`/search?q=title:${productTitle[0]}&type=product&view=api`)
    .then((response) => response.json())
    .then((data) => {
      data.forEach((item) => {
        let colorIndex = item.options.indexOf("Color");
        let colorTitle = item.title.split(" - ")[0];
        if (colorTitle != productTitle[0]) return true;
        if (colorIndex == -1) return true;
        let color = item.variants[0].options[colorIndex];
        const checked =
          window.productJSON.variants[0].options[0] === color ? "checked" : "";
        let swatch = document.createElement("div");
        swatch.classList.add("variant-radio");
        swatch.innerHTML = `
		<input type="radio" 
			   id="color-swatch__${item.id}" 
               name="Color" 
               ${checked}
			   value="${color}" 
			   data-url="/products/${item.handle}"
			   form="product-form-template--${window.productJSON.id}__main">
        <label for="color-swatch__${item.id}" aria-label="Color Swatch - ${color}"><span class="visually-hidden">${color}</span></label>
      `;
        document
          .querySelector('.product-form__input[data-option="Color"]')
          .appendChild(swatch);
        const itemVariants = item.variants;
        itemVariants.forEach((v) => {
          v.productUrl = "/products/" + item.handle;
        });

        window.productJSON.variants.push(...itemVariants);

        getSwatches(productTitle[0]);
      });
      if (!customElements.get("variant-selects")) {
        customElements.define("variant-selects", VariantSelects);
      }
      
      if (!customElements.get("variant-radios")) {
        customElements.define("variant-radios", VariantRadios);
      }
    })
    .catch((e) => console.log(e));
}

function equalButtonsMobile() {
  if (window.innerWidth >= 750) return;
  const variantRadios = document.querySelectorAll(
    '.product-form__input[data-option="Size"] .variant-radio label'
  );
  let maxItemWidth = 0;

  variantRadios.forEach((radio) => {
    const variantWidth = radio.offsetWidth;
    maxItemWidth = Math.max(maxItemWidth, radio.offsetWidth);
  });

  variantRadios.forEach((radio) => {
    radio.style.width = maxItemWidth + "px";
  });
}

const findMySize = () => {
  const findMySizeButton = document.querySelector(".link--find-my-size");
  if (!findMySizeButton) return;
  const sizeAccordion = document.querySelector(
    "#product-accordion__size-guide details"
  );
  findMySizeButton.addEventListener("click", (event) => {
    event.preventDefault();
    sizeAccordion.setAttribute("open", true);
    sizeAccordion.scrollIntoView();
  });
};

(function () {
  const reviewLink = document.querySelector(".write-review-link");

  if (reviewLink) {
    reviewLink.addEventListener("click", (event) => {
      const newReviewForm = document.querySelector(".new-review-form");
      newReviewForm.style.display = "block";
      newReviewForm.attribute("aria-expanded", true);
    });
  }

  playPauseVideo();

  /* Fancy Swatches */
  fancySwatches();

  document.fonts.ready.then(function () {
    equalButtonsMobile();
  });

  findMySize();
})();